import apiClient, { unwrap } from './client';

export const notificationsApi = {
  getAll: async () => {
    const res = await apiClient.get('/notifications', { params: { size: 50, sort: 'createdAt,desc' } });
    const page = unwrap(res);
    return page?.content ?? page ?? [];
  },

  getUnreadCount: async () => {
    const res = await apiClient.get('/notifications/unread-count');
    return unwrap(res) ?? 0;
  },

  markRead: async (id) => {
    await apiClient.put(`/notifications/${id}/read`);
  },

  markAllRead: async () => {
    await apiClient.put('/notifications/read-all');
  },

  remove: async (id) => {
    await apiClient.delete(`/notifications/${id}`);
  },
};
